import QRCode from "react-qr-code";
import { formatBadgeName } from "../../utils/formatBadgeName";

type Props = {
  name: string;
  institution?: string;
  qrValue: string;
  /** id do elemento raiz (ex.: content-to-print) */
  id?: string;
  /** tamanho do QR só na prévia em tela (px) */
  previewQrSize?: number;
  /** Mostra moldura da folha 60×40 mm (só tela; não entra na impressão se id estiver no badge) */
  showPaperFrame?: boolean;
};

/**
 * Conteúdo do crachá na área útil 56×36 mm (folha 60×40 com margem de 2 mm).
 * O elemento com class "badge" (e id, se houver) é o que vai para a impressão.
 */
export function BadgeLabel({
  name,
  institution = "",
  qrValue,
  id,
  previewQrSize = 68,
  showPaperFrame = true,
}: Props) {
  const displayName = formatBadgeName(name);

  const badge = (
    <div
      id={id}
      className="badge flex h-[36mm] w-[56mm] flex-row items-center gap-[1.5mm] overflow-hidden bg-white px-[1.5mm] py-[1mm]"
    >
      <div className="badge-qr flex h-[18mm] w-[18mm] shrink-0 items-center justify-center">
        <QRCode value={qrValue} size={previewQrSize} />
      </div>
      <div className="badge-info flex min-w-0 max-w-[34mm] flex-1 flex-col justify-center gap-[0.8mm] overflow-hidden">
        <h2 className="badge-name m-0 max-w-[34mm] line-clamp-2 break-words text-[7pt] font-bold leading-tight text-zinc-800">
          {displayName}
        </h2>
        {institution ? (
          <p className="badge-institution m-0 max-w-[34mm] line-clamp-2 break-words text-[5.5pt] font-semibold leading-tight text-zinc-600">
            {institution}
          </p>
        ) : null}
      </div>
    </div>
  );

  if (!showPaperFrame) {
    return badge;
  }

  return (
    <div className="flex h-[40mm] w-[60mm] items-center justify-center border border-dashed border-zinc-300 bg-zinc-50">
      {badge}
    </div>
  );
}
